import { RocketOutlined, SettingOutlined } from '@ant-design/icons';

import SettingsPage from '../pages/SettingsPage';
import PromotionPage from 'src/pages/PromotionPage/PromotionPage';

import { SiteMap } from './index';

export const settingsRoutes: SiteMap = {
  promotion: {
    title: '프로모션',
    page: PromotionPage,
    icon: <RocketOutlined />,
    role: ['admin'],
    key: '/promotion',
  },
  settings: {
    title: '설정',
    page: SettingsPage,
    icon: <SettingOutlined />,
    role: ['admin'],
    key: '/settings',
  },
};
